import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { SFErrorBoundary } from '@/components/ErrorBoundary';
import { TopNavStyles } from '@/components/TopNav/TopNav.styles';
import useUser from '@/hooks/useUser';
import selectUserType from '@/store/user/selectors/selectUserType';
import useTranslation from '@/hooks/useTranslation';
import useContentful from '@/hooks/useContentful';

const NavLogin = (): JSX.Element | null => {
  const { t } = useTranslation();
  const router = useRouter();
  const user = useUser();
  const { isLoggedIn } = selectUserType(user);
  const { globalSettings } = useContentful();

  if (isLoggedIn) return null;

  const handleLoginClick = () => {
    sessionStorage.setItem('preLoginRoute', router.asPath);
    router.push('/login');
  };

  return (
    <SFErrorBoundary targetComponent="LOGIN" fallbackComponent={undefined}>
      <button
        aria-label="Login Signup Cta Text"
        style={TopNavStyles.navLoginButton}
        onClick={handleLoginClick}>
        {globalSettings
          ? globalSettings.loginSignupCtaText
          : t('login.discount')}
      </button>
    </SFErrorBoundary>
  );
};

export default NavLogin;
